import * as Sentry from '@sentry/vue'
import type { Router } from 'vue-router'

export default defineNuxtPlugin((nuxtApp) => {
  const { public: { NUXT_ENV, NUXT_SENTRY_DSN } } = useRuntimeConfig()
  const isProduction = NUXT_ENV === 'production'

  if (!isProduction && !NUXT_SENTRY_DSN) return

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: NUXT_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router: nuxtApp.$router as Router })
    ],
    environment: NUXT_ENV,
    ignoreErrors: [
      /ResizeObserver loop/
    ]
  })
})
